module.exports = __webpack_public_path__ + "img/collection-weddingRingsFrameSettings@2x.97d5f55.webp";